import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { PermissionHelper } from '../helpers/permission.helper';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.navigationService.setCurrentRoute(route);

    const module = this.navigationService.currentModule;
    const page = this.navigationService.currentPage;
    const subPage = this.navigationService.currentSubPage;

    const permissions = PermissionHelper.getPagePermissions(module, page, subPage);
    const featureFlag = PermissionHelper.getPageFeatureFlag(module, page, subPage);
    if ((permissions == null || this.authService.hasAnyPermission(permissions)) && (featureFlag == null || this.authService.hasFeatureFlag(featureFlag))) {
      return true;
    }

    await this.navigationService.navigateToNotFound(true);
    return false;
  }
}
